<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      noTraslado :  this.$route.params.id,
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },

      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        total_adelanto: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      detalleProducto : [],
      detalleServicio :[]
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "traslados/view?id=" +
            this.noTraslado,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
        me.detalleProducto = response.data.data.detalle_traslados;

          me.formPro.no_orden = response.data.data.no_traslado;
          me.formPro.user = response.data.data.user.empleado.persona.nombre_persona + ' ' + response.data.data.user.empleado.persona.apellido_persona;
          me.formPro.fecha_venta = response.data.data.fecha_traslado;
          me.formPro.bodega_envia = response.data.data.envia.nombre_bodega;
          me.formPro.bodega_recibe = response.data.data.recibe.nombre_bodega;

          me.formPro.state = response.data.data.estado_traslado;
            console.log(response)
        //   console.log(me.detalleProducto, me.detalleServicio);


        });
    },
    sumarPagosTaller(pagos){
      console.log(pagos)
        return pagos.reduce((total, item) => {
          let monto = parseFloat(item.adelanto); // Convierte el valor a número
          if (!isNaN(monto)) { // Verifica si es un número válido
              return total + monto;
          }
          return total;
      }, 0);
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'traslados' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Comprobante -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body rt">
            <!-- Header corporativo -->
            <div class="rt-header">
              <div class="rt-brand">
                <img :src="logoUrl" alt="Logo" class="rt-logo" />
                <div>
                  <div class="rt-name">Taller de Reparación Ariel</div>
                  <div class="rt-contact"><i class="bx bx-phone"></i> 4889 9653 · 4477 4533</div>
                  <div class="rt-contact"><i class="bx bx-map"></i> Comapa, Jutiapa</div>
                </div>
              </div>
              <div class="rt-doc">
                <div class="rt-doc-title">COMPROBANTE DE TRASLADO</div>
                <div class="rt-doc-no">No. {{ formPro.no_orden }}</div>
                <div class="rt-doc-date">Fecha: {{ formPro.fecha_venta }}</div>
              </div>
            </div>

            <!-- Origen / Destino -->
            <div class="rt-info">
              <div class="rt-info-col">
                <div class="rt-info-label">Tienda / bodega que envía</div>
                <div class="rt-info-value">{{ formPro.bodega_envia }}</div>
                <div class="rt-info-sub">Usuario: {{ formPro.user }}</div>
              </div>
              <div class="rt-arrow"><i class="bx bx-right-arrow-alt"></i></div>
              <div class="rt-info-col">
                <div class="rt-info-label">Tienda / bodega que recibe</div>
                <div class="rt-info-value">{{ formPro.bodega_recibe }}</div>
              </div>
            </div>

            <!-- Productos -->
            <div class="rt-section">Repuestos y materiales trasladados</div>
            <table class="rt-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th class="c">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleProducto" v-bind:key="idx">
                  <td>{{ item.producto.nombre_producto }}</td>
                  <td class="c">{{ quantity(item.cantidad) }} Unidad(es)</td>
                </tr>
              </tbody>
            </table>

            <!-- Firmas -->
            <div class="rt-firmas">
              <div class="rt-firma">
                <div class="rt-firma-linea"></div>
                <strong>Firma de quien envía</strong>
                <div class="rt-firma-label">{{ formPro.user + ' -- ' + formPro.bodega_envia }}</div>
              </div>
              <div class="rt-firma">
                <div class="rt-firma-linea"></div>
                <strong>Firma de quien recibe</strong>
                <div class="rt-firma-label">{{ formPro.bodega_recibe }}</div>
              </div>
            </div>

            <div class="rt-footer">Taller de Reparación Ariel · Comprobante de traslado</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.rt { color: #2b2f3a; font-size: 13px; }

.rt-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 18px;
}
.rt-brand { display: flex; align-items: center; gap: 16px; }
.rt-logo { height: 78px; width: auto; object-fit: contain; border-radius: 8px; }
.rt-name { font-size: 23px; font-weight: 800; color: #1b2a4e; line-height: 1.1; }
.rt-contact { font-size: 12px; color: #6b7280; margin-top: 2px; }
.rt-doc { text-align: right; }
.rt-doc-title {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 13px;
  padding: 6px 14px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.rt-doc-no { font-size: 19px; font-weight: 800; color: #c5a253; margin-top: 6px; }
.rt-doc-date { font-size: 12px; color: #6b7280; }

.rt-info {
  display: flex; align-items: center; gap: 12px;
  background: #f7f9fc; border: 1px solid #e7e9ef; border-radius: 8px;
  padding: 14px 18px; margin-bottom: 18px;
}
.rt-info-col { flex: 1; }
.rt-arrow { font-size: 26px; color: #c5a253; }
.rt-info-label { font-size: 10px; color: #8a909c; text-transform: uppercase; letter-spacing: .5px; }
.rt-info-value { font-size: 16px; font-weight: 700; color: #1b2a4e; }
.rt-info-sub { font-size: 12px; color: #6b7280; }

.rt-section {
  font-size: 14px; font-weight: 700; color: #1b2a4e;
  margin: 18px 0 8px; padding-left: 10px; border-left: 4px solid #c5a253;
}

.rt-table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
.rt-table thead th {
  background: #1b2a4e; color: #fff; font-size: 11px; font-weight: 600;
  text-transform: uppercase; padding: 9px 10px; text-align: left;
}
.rt-table tbody td { padding: 8px 10px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.rt-table tbody tr:nth-child(even) { background: #f9fafc; }
.rt-table .c { text-align: center; }

.rt-firmas { display: flex; gap: 40px; margin-top: 60px; }
.rt-firma { flex: 1; text-align: center; }
.rt-firma-linea { border-top: 1px solid #2b2f3a; margin-bottom: 6px; }
.rt-firma-label { font-size: 12px; color: #6b7280; }

.rt-footer {
  margin-top: 26px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .rt, .rt * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
